export default "__VITE_ASSET__D6GF0FVc__"